var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"value":_vm.selected,"outlined":"","items":_vm.teams,"label":"Region/Team","data-cy":"team-dropdown","multiple":"","small-chips":"","disabled":!_vm.$store.getters.enterprise,"no-data-text":"No regions"},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }